import { ReactNode, useState } from 'react';
import { PLACEMENT, Popover } from 'baseui/popover';

import { popOverrides } from '@/components/popOverride';
import { WorkspacePopoverContent } from '@/pages/workgroup/tab/General';
import { ConfirmResumeWorkspace } from '@/pages/workgroup/tab/SettingMenu';
import { DatabaseT, WorkGroupT, WorkspaceT } from '@/pages/workgroup/type';

export function WorkspaceNamePopover({
  workspace,
  database,
  group,
  children,
  className,
}: {
  workspace: WorkspaceT;
  database?: DatabaseT;
  group: WorkGroupT;
  children: ReactNode;
  className?: string;
}) {
  const [showPopover, setShowPopover] = useState(false);
  const [showResume, setShowResume] = useState(false);

  const delayClose = () => {
    setTimeout(() => {
      setShowPopover(false);
    }, 100);
  };

  return (
    <>
      <Popover
        isOpen={showPopover}
        onEsc={delayClose}
        // Click-outside is intentionally a no-op because the popover content
        // includes nested dropdown menus that render in portals. Treating those
        // portal clicks as "outside" would dismiss the popover unexpectedly.
        // Users dismiss the popover via the X button or Esc.
        onClickOutside={() => {}}
        // baseui's Popover overrides the anchor element's onClick via cloneElement,
        // so we must use the Popover's own onClick prop (which baseui invokes from
        // its internal onAnchorClick handler) rather than putting onClick on the span.
        onClick={(e) => {
          e.stopPropagation();
          setShowPopover((prev) => !prev);
        }}
        content={
          <WorkspacePopoverContent
            workspace={workspace}
            database={database}
            onClose={() => setShowPopover(false)}
            onResume={() => setShowResume(true)}
            group={group}
          />
        }
        placement={PLACEMENT.bottom}
        overrides={popOverrides}
        autoFocus={false}
      >
        <span className={className} style={{ cursor: 'pointer' }} title={workspace.name}>
          {children}
        </span>
      </Popover>
      {showResume ? (
        <ConfirmResumeWorkspace isOpen={showResume} onClose={() => setShowResume(false)} workspace={workspace} />
      ) : null}
    </>
  );
}
